import { serverTimeFunc } from '@/utils/serverTime'

export default {
    install(Vue, option) {
        Vue.prototype.$formatter = new (function () {
            this.generateId = (id) => {
                return `#${this.pad(id, 5)}`;
            }

            this.generateOrderId = (order) => {
                if (order.order_code) {
                    return order.order_code;
                }
                return `DN-${order.id}`;
            }

            // ------ Date related
            /**
            * 
            * @param {String} d - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]
            * @returns Number - weekday number
            */
            this.getDay = (d) => {
                if (d.length > 10) {
                    return this.getDateObj(`${d.split('T')[0]}T12:00:00Z`).getDay();
                }

                return this.getDateObj(`${d}T12:00:00Z`).getDay();
            }

            this.convertStrToDate = (d) => {
                if (d.length > 10) {
                    return this.getDateObj(`${d.split('T')[0]}T12:00:00Z`);
                }

                return this.getDateObj(`${d}T12:00:00Z`);
            }

            /**
             * 
             * @param {Number} year 
             * @param {Number} month - start from 0 to 6
             * @param {Number} date 
             */
            this.formatDateToDate = (year, month, date) => {
                return this.convertStrToDate(`${year}-${this.pad(month + 1)}-${this.pad(date)}`);
            }

            /**
            * 
            * @param {String} e - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]
            * @returns Number - date
            */
            this.dayFormat = (e) => {
                return parseInt(e.substring(8, 10), 10).toString()
            }

            /**
             * 
             * @param {*} d - new Date()
             * @returns String - YYYY-MM-DD
             */
            this.formatDate = (d, time = false) => {
                let s = `${d.getFullYear()}-${d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1}-${d.getDate() < 10 ? `0${d.getDate()}` : d.getDate()}`;
                if (time) {
                    s += 'T';
                    s += (d.getHours() < 10 ? `0${d.getHours()}` : d.getHours()) + ':';
                    s += (d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()) + ':';
                    s += (d.getSeconds() < 10 ? `0${d.getSeconds()}` : d.getSeconds()) + 'Z';
                }
                return s;
            }

            /**
             * @param {string} d - YYYY-MM-DD | [YYYY-MM-DD]T[HH:MM:SS]Z
             */
            this.strtotime = (d) => {
                return Math.floor(this.getDateObj(d).getTime() / 1000);
            }

            this.getNowTime = () => {
                return this.strtotime(serverTimeFunc.getServerCurrentTime());
            }

            this.dateTimeToDate = (datetime, separator = "/", skipYear = false) => {
                const y = datetime.substring(0, 4)
                const m = datetime.substring(5, 7)
                const d = datetime.substring(8, 10)

                if (skipYear) {
                    return `${d}${separator}${m}`
                }

                if (separator === '-') {
                    return `${y}${separator}${m}${separator}${d}`
                }

                return `${d}${separator}${m}${separator}${y}`
            }

            // ----- Others
            /**
             * 
             * @param {Number | String} n - text/number will be padded
             * @param {Number} l - padded text length
             * @param {String} c - added string 
             * @param {Boolean} r - add text to left-hand-side
             * @param {Boolean} b 
             * @returns 
             */
            this.pad = (n, l, c, r, b) => {
                var s = n.toString(),
                    l = l || 2,
                    r = r !== false,
                    b = b !== false;
                if (s.length > 0) {
                    var p = "";
                    if (!isNaN(n) && s.charAt(0) == "-") {
                        p = "-";
                        s = s.substring(1);
                    }
                    while (s.length < l) {
                        if (r) s = (c || "0") + s;
                        else s += c || "0";
                    }
                    return b ? p + s : s;
                } else return "";
            }

            this.separator = (n, c, l) => {
                var l = l || 3;
                var r = new RegExp("\\B(?=(\\d{" + l + "})+(?!\\d))", "g");
                var p = n.toString().split(".");
                p[0] = p[0].replace(r, c || ",");
                return p.join(".");
            }

            /**
             * 
             * @param {Number} number 
             * @param {Number} decPlace - 取小數點後幾多個位
             * @returns Number
             */
            this.roundUp = (number, decPlace = 1) => {
                const multiplier = Math.pow(10, decPlace || 0);
                return Math.ceil(parseFloat(number) * multiplier) / multiplier;
            }

            this.formatMoney = (number) => {
                return this.roundUp(number);
            }

            // ----- Keydown Events
            this.number = event => {
                // [0-9]
                if (event.charCode >= 48 && event.charCode <= 57) {
                    return true
                }

                return event.preventDefault()
            }

            this.floating = event => {
                // [0-9][.][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46) {
                    return true
                }

                return event.preventDefault()
            }

            this.numberWithNegative = event => {
                // [-][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 45) {
                    return true
                }

                return event.preventDefault()
            }

            this.floatingWithNegative = event => {
                // [-][0-9][.][0-9]
                if ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46 || event
                    .charCode === 45) {
                    return true
                }

                return event.preventDefault()
            }

            this.alphaNumeric = event => {
                // [0-9A-Za-z]
                if (
                    (event.charCode >= 48 && event.charCode <= 57) ||
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122)
                ) {
                    return true
                }

                return event.preventDefault()
            }

            this.phone = event => {
                // +[0-9]
                if (event.charCode >= 48 && event.charCode <= 57 || event.charCode === 43) {
                    return true
                }

                return event.preventDefault()
            }

            this.engName = event => {
                // [a-zA-Z\s.,]
                if (
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) ||
                    event.charCode === 32 || event.charCode === 46 || event.charCode === 188
                ) {
                    return true
                }

                return event.preventDefault()
            }

            this.id = event => {
                // #[0-9]
                if (event.charCode >= 48 && event.charCode <= 57 || event.charCode === 35) {
                    return true
                }

                return event.preventDefault()
            }

            this.splitYMDHms = (date) => {
                let y = "", month = "", d = "", h = "", min = "", s = ""
                if (Vue.prototype.$validate.DataValid(date)) {

                    const splitDateTime = date.split('T');
                    const splitDate = splitDateTime[0]
                    const splitTime = splitDateTime.length > 1 ? splitDateTime[1].split('Z')[0] : "";
                    return {
                        y: splitDate.substring(0, 4),
                        month: splitDate.substring(5, 7),
                        d: splitDate.substring(8, 10),
                        h: splitTime.substring(0, 2),
                        min: splitTime.substring(3, 5),
                        s: splitTime.substring(6, 8)
                    }
                }

                return { y, month, d, h, min, s }
            }

            this.getDateObj = (date) => {
                const { y, month, d, h, min, s } = this.splitYMDHms(date)
                return new Date(parseInt(y), parseInt(month) - 1, parseInt(d), parseInt(h) || 8, parseInt(min) || 0, parseInt(s) || 0)
            }

            this._splitDatetime = (d) => {
                let obj = {
                    date: '',
                    time: ''
                }
                if (/^\d{4}-\d{2}-\d{2}$/.test(d) || /^\d{4}\/\d{2}\/\d{2}$/.test(d)) {
                    obj.date = d;
                } else if (/([0-9]{4}-[0-9]{2}-[0-9]{2})(T[0-9]{2}:[0-9.]+(:[0-9.]+)?)?Z?/) {
                    obj.date = d.substring(0, 10);
                    obj.time = d.substring(11, 19);
                }
                return obj;
            }

            this.sortDate = (a, b) => {
                const { date: aDate, time: aTime } = this._splitDatetime(a);
                const { date: bDate, time: bTime } = this._splitDatetime(b);
                const aDateObj = this.convertStrToDate(aDate, aTime);
                const bDateObj = this.convertStrToDate(bDate, bTime);
                return aDateObj.getTime() - bDateObj.getTime();
            }
        })()
    }
}